import { push } from 'react-router-redux';

// Dispatch a route change programmatically
export function changeRoute(location) {
  return (dispatch) => {
    dispatch(push(location));
  };
}
